import IconButton from "./IconButton";

export {
    IconButton as default,
};
